import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { ActivityIndicator } from "components/activity-indicator"
import { EmptyState } from "components/empty-state"
import { InfiniteScrollLoadMore } from "components/infinite-scroll-load-more"
import { SessionCardContainer } from "components/sessions/SessionCardContainer"
import useCurrent from "lib/use-current"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import pluralize from "pluralize"
import { isNilOrEmpty } from "utils/helpers"

const useStyles = makeStyles()(
  (theme) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      minHeight: "400px",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    cardsListContainer: {
      display: "grid",
      gridGap: theme.spacing(3),
      gridTemplateColumns: "1fr",

      width: "100%",
    },
    emptyStateContainer: {
      gridColumn: "1/-1",
    },
  }),
)

interface ISessionsList {
  sessions: ConventionSession[]
  userSessionIds: Record<string, boolean>
  isLoading: boolean
  isReady: boolean
  onLoadMore: () => void
  hasMore: boolean
  onSetReminder: (sessionId: string) => void
  onRemoveReminder: (sessionId: string) => void
}

export const SessionsList = (props: ISessionsList) => {
  const {
    sessions,
    userSessionIds,
    isLoading,
    isReady,
    onLoadMore,
    hasMore,
    onSetReminder,
    onRemoveReminder,
  } = props
  const { classes } = useStyles()

  const current = useCurrent()

  if (!isReady || !current) {
    return (
      <Box className={classes.container}>
        <ActivityIndicator />
      </Box>
    )
  }

  const hasSessions = !isNilOrEmpty(sessions)

  return (
    <Box className={classes.container}>
      <Box className={classes.cardsListContainer}>
        {hasSessions ? (
          sessions.map((session) => (
            <SessionCardContainer
              onSetReminder={onSetReminder}
              onRemoveReminder={onRemoveReminder}
              key={session.id}
              session={session}
              userSessionIds={userSessionIds}
            />
          ))
        ) : (
          <Box className={classes.emptyStateContainer}>
            <EmptyState
              title="🤔"
              subtitle={`No ${pluralize(current.config.session_copy_text)} found.`}
            />
          </Box>
        )}
      </Box>

      {hasSessions && (
        <InfiniteScrollLoadMore
          showButton={hasMore}
          disableButton={isLoading}
          onButtonPress={onLoadMore}
        />
      )}
    </Box>
  )
}
